import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  star: {
    color: '#ff0300',
  },
}));

const RedStar = () => {
  const classes = useStyles();
  return <span className={classes.star}>*</span>;
};

export default RedStar;
